// extracted by mini-css-extract-plugin
export default {"mask-hover":"rs4BMOv2XMX8ikB6YOR_","type-btn":"sruwGLsl05F0ewzl6EMN","type-play":"nEAN7K5b1TeKOq3qQFnH","common_bganimation":"vDLzSnzUitIol2WZ03au"};